import ActionTypes from "./types";

export default (searchValue) => {
  return {
    type: ActionTypes.SET_GLOBAL_SEARCH_VALUE,
    payload: searchValue,
  };
};
